import React, { useEffect } from 'react'
import useQueryString from '../hooks/useQueryString'

import { axiosPost } from '../utils/axios'
import { removeSessionStorage, keyNameSessionStorage, setSessionStorage } from '../utils/sessionStorage'
import useStore from '../stores/useStore'
import apiUrl from '../configs/apiUrl'
import { pathNames } from '../routers/router'

const useLandingPageSelf = () => {
    const { values: cmsToken } = useQueryString({ keys: ['accessToken', 'refreshToken'] })
    const [cmsAcceptToken, cmsRefreshToken] = cmsToken
    const { userStore } = useStore()

    useEffect(() => {
        loginSelf()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const onCallBack = async () => {
        if (cmsAcceptToken && cmsRefreshToken) {
            try {
                await userStore.getUserProfile()
                await goToPortalSelf()
            } catch (error) {
                removeSessionStorage([
                    keyNameSessionStorage.user,
                    keyNameSessionStorage.accessToken,
                    keyNameSessionStorage.refreshToken,
                ])
            }
        } else {
        }
    }

    const loginSelf = async () => {
        if (cmsRefreshToken) {
            const newToken = axiosPost<
                {
                    accessToken: string
                    refreshToken: string
                },
                { refreshToken: string }
            >({
                url: apiUrl.getNewTokenSelf,
                params: {
                    refreshToken: cmsRefreshToken,
                },
            })
            const response = await newToken.request
            if (response.data && response.data.refreshToken && response.data.accessToken) {
                setSessionStorage(keyNameSessionStorage.accessToken, response.data.accessToken)
                setSessionStorage(keyNameSessionStorage.refreshToken, response.data.refreshToken)
                onCallBack()
            }
        }
    }
    const goToPortalSelf = () => {
        //ต้อง Reload ใหม่ เพราะ SessionStorage ไม่ถูกเปลี่ยน
        window.location.href = process.env.PUBLIC_URL + pathNames.userOverview
    }
    return { userStore }
}

let LandingPageSelf = () => {
    const landingPageSelf = useLandingPageSelf()
    console.log(landingPageSelf)
    return <></>
}

export default LandingPageSelf
